<template>
  <div class="container h6 c-gray60 m-y-2 p-y-2">
    Pro Referral verifies national and state-level licensing where applicable.
    Some states either do not require licensing or license at the local level.
    Before hiring a pro, we recommend contacting your local government to
    confirm they are properly licensed.
  </div>
</template>

<script>
export default {
  name: 'pro-licensing',
};
</script>
